import { render } from "./BnkV3.vue?vue&type=template&id=5b6f53b1&scoped=true"
import script from "./BnkV3.vue?vue&type=script&lang=js"
export * from "./BnkV3.vue?vue&type=script&lang=js"

import "./BnkV3.vue?vue&type=style&index=0&id=5b6f53b1&scoped=true&lang=css"
import "./BnkV3.vue?vue&type=style&index=1&id=5b6f53b1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6f53b1"]])

export default __exports__